import script from "./TeamMemberCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMemberCard.vue?vue&type=script&setup=true&lang=js"

import "./TeamMemberCard.vue?vue&type=style&index=0&id=8d78fe1c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d78fe1c"]])

export default __exports__